import { type BoxProps, Stack } from "@mui/material";
import { type ReactNode } from "react";

import { type IntentVariant } from "../../../ui-theme";
import { mergeSxProps } from "../../lib/mergeSxProps";
import { CbhIcon, type IconType } from "../CbhIcon";
import { Text } from "../Text";

export interface SystemInlineBannerProps extends Omit<BoxProps, "color"> {
  iconType: IconType;
  color: IntentVariant;
  children: ReactNode;
}

/**
 * A horizontal banner component that displays an icon alongside text content.
 * Used for system messages, notifications, and informational content.
 */
export function SystemInlineBanner(props: SystemInlineBannerProps) {
  const { iconType, color, children, sx } = props;

  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={mergeSxProps(
        (theme) => ({
          gap: 3,
          paddingY: 4,
          paddingX: 5,
          backgroundColor: theme.palette.intent?.[color]?.background,
          color: theme.palette.intent?.[color]?.text,
          borderRadius: theme.borderRadius?.small,
        }),
        sx
      )}
    >
      <CbhIcon type={iconType} color={(theme) => theme.palette.intent?.[color]?.icon} />
      <Text variant="body2" sx={{ color: "inherit" }}>
        {children}
      </Text>
    </Stack>
  );
}
